import {AudioPresets} from "livekit-client";

const DATA_SAVER_BITRATE_KBPS = 24;
const HIGH_FIDELITY_BITRATE_KBPS = 48;

const normalizeCallAudioBitrateKbps = (value) =>
  Number(value) === DATA_SAVER_BITRATE_KBPS ?
    DATA_SAVER_BITRATE_KBPS : HIGH_FIDELITY_BITRATE_KBPS;

const callAudioPublishDefaults = (value) => ({
  audioPreset: normalizeCallAudioBitrateKbps(value) ===
    DATA_SAVER_BITRATE_KBPS ? AudioPresets.speech : AudioPresets.music,
  // Preserve silence savings and packet-loss protection in both modes.
  dtx: true,
  red: true,
});

export {
  DATA_SAVER_BITRATE_KBPS,
  HIGH_FIDELITY_BITRATE_KBPS,
  callAudioPublishDefaults,
  normalizeCallAudioBitrateKbps,
};
